"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _solarReact = require("@solar/solar-react");

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _excluded = ["className", "value", "fullWidth", "InputProps", "onChange", "mobileVersion", "placeholder", "toggleWidth"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: theme.increments.tablet * 6,
      marginRight: 8,
      marginLeft: 8
    },
    mobileSearchField: {
      width: '100%'
    },
    searchIcon: {
      "float": 'right'
    }
  };
});

var SearchField = function SearchField(_ref) {
  var classNameProp = _ref.className,
      value = _ref.value,
      fullWidth = _ref.fullWidth,
      InputProps = _ref.InputProps,
      _onChange = _ref.onChange,
      mobileVersion = _ref.mobileVersion,
      placeholder = _ref.placeholder,
      toggleWidth = _ref.toggleWidth,
      other = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  var className = (0, _classnames["default"])(classes.root, classNameProp, mobileVersion ? classes.mobileSearchField : null);
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, fullWidth ? /*#__PURE__*/_react["default"].createElement(_solarReact.LightTextField, _extends({
    fullWidth: true,
    box: true,
    placeholder: placeholder || 'zoeken...',
    value: value,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    },
    className: className,
    InputProps: _objectSpread(_objectSpread({}, InputProps), {}, {
      disableUnderline: true,
      startAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "start",
        onClick: toggleWidth
      }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
        color: "inherit"
      }))
    }, value.length > 0 ? {
      endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        color: "inherit",
        onClick: function onClick() {
          return _onChange('');
        }
      }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        color: "inherit"
      })))
    } : {})
  }, other)) : /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "inherit",
    onClick: toggleWidth,
    classes: {
      root: classes.searchIcon
    }
  }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
    color: "inherit"
  })), ' ');
};

SearchField.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  className: _propTypes["default"].string,
  fullWidth: _propTypes["default"].bool,
  InputProps: _propTypes["default"].object,
  mobileVersion: _propTypes["default"].bool,
  onChange: _propTypes["default"].func.isRequired,
  placeholder: _propTypes["default"].string,
  toggleWidth: _propTypes["default"].func,
  value: _propTypes["default"].string
};
SearchField.defaultProps = {
  className: '',
  value: ''
};
var _default = SearchField;
exports["default"] = _default;